import React from 'react'

import { ListLinksProps } from './list-links.d';

import ListLinks from '/react4xp/components/ListLinks'

function ListLinksPart(props: ListLinksProps) {
    return <ListLinks {...props} />
}

export default (props) => <ListLinksPart {...props} />
